import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard'),
        meta: {
          breadcrumb: [{
            name: 'Dashboard',
            name_i18n: '__dashboard',
          }]
        }
      },
      {
        path: 'jobAssignmentList',
        name: 'JobAssignmentList',
        component: () => import('@/views/JobAssignmentList'),
        meta: {
          breadcrumb: [{
            name: '工作指派列表',
            name_i18n: '__jobAssignmentList',
          }]
        }
      },
      {
        path: 'jobAssignment',
        name: 'jobAssignment',
        component: () => import('@/views/JobAssignment'),
        meta: {
          breadcrumb: [{
            name: '工作指派列表',
            name_i18n: '__jobAssignmentList',
            link: 'JobAssignmentList'
          },
          {
            name: '詳細資料',
            name_i18n: '__detail',
          }]
        }
      },
      {
        path: 'historyRecordList',
        name: 'historyRecordList',
        component: () => import('@/views/HistoryRecordList'),
        meta: {
          breadcrumb: [{
            name: '歷史紀錄列表',
            name_i18n: '__historyRecordList',
          }]
        }
      },
      {
        path: 'WarrantyAndMaintenance',
        name: 'WarrantyAndMaintenance',
        component: () => import('@/views/WarrantyAndMaintenance'),
        meta: {
          breadcrumb: [{
            name: '保固與維護',
            name_i18n: '__warrantyAndMaintenance',
          }]
        }
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: () => import('@/views/Maintenance'),
        meta: {
          breadcrumb: [{
            name: '保固與維護',
            name_i18n: '__warrantyAndMaintenance',
            link: 'WarrantyAndMaintenance'
          },
          {
            name: '詳細資料',
            name_i18n: '__detail',
          }]
        }
      },
      {
        path: 'device',
        name: 'device',
        component: () => import('@/views/Device'),
        meta: {
          breadcrumb: [{
            name: '保固與維護',
            name_i18n: '__warrantyAndMaintenance',
            link: 'WarrantyAndMaintenance'
          },
          {
            name: '詳細資料',
            name_i18n: '__detail',
          }]
        }
      },
      {
        path: 'Configuration',
        name: 'Configuration',
        component: () => import('@/views/Configuration'),
        meta: {
          breadcrumb: [{
            name: '保固與維護',
            name_i18n: '__Configuration',
          }]
        }
      },
      {
        path: 'organization',
        name: 'organization',
        component: () => import('@/views/Organization'),
        meta: {
          breadcrumb: [{
            name: '設定',
            name_i18n: '__Configuration',
            link: 'Configuration'
          },
          {
            name: '詳細資料',
            name_i18n: '__Organization',
          }]
        }
      },
      {
        path: 'staff',
        name: 'staff',
        component: () => import('@/views/Staff'),
        meta: {
          breadcrumb: [{
            name: '設定',
            name_i18n: '__Configuration',
            link: 'Configuration'
          },
          {
            name: '詳細資料',
            name_i18n: '__Staff',
          }]
        }
      },
      {
        path: 'customer',
        name: 'customer',
        component: () => import('@/views/Customer'),
        meta: {
          breadcrumb: [{
            name: '設定',
            name_i18n: '__Configuration',
            link: 'Configuration'
          },
          {
            name: '詳細資料',
            name_i18n: '__Customer',
          }]
        }
      },
      {
        path: 'editProfile',
        name: 'editProfile',
        component: () => import('@/views/EditProfile'),
        meta: {
          breadcrumb: [{
            name: 'Edit Profile',
            name_i18n: '__editProfile',
          }]
        }
      },


      // {
      //   path: 'couponOptions',
      //   name: 'couponOptions',
      //   component: () => import('@/views/CouponOptions'),
      //   meta: {
      //     breadcrumb: [{
      //       name: '紅利兌換',
      //       name_i18n: '__coupon',
      //     },
      //     {
      //       name: '兌換選項總覽',
      //       name_i18n: '__couponOptionsList',
      //       link: 'couponOptionsList'
      //     },
      //     {
      //       name: '詳細記錄',
      //       name_i18n: '__detail',
      //     }]
      //   }
      // },


    ]
  },

  {
    path: '/login',
    component: () => import('@/views/Login'),
  },
  { path: '*', redirect: '/' }

  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     // meta: { title: 'Dashboard', icon: 'dashboard' }
  //   }]
  // },
]

const router = new VueRouter({
  routes
})

export default router
